/* In-collection search — Matraws.
   Lazily builds a client-side index of ALL products in the current collection
   (via /collections/<handle>/products.json), then filters by title as you type.
   Collection-scoped only — never site-wide. */
(function () {
  if (window.__mtwColSearch) return;
  window.__mtwColSearch = 1;

  var MAX_RESULTS = 100;     // cap rendered DOM nodes
  var PAGE_SIZE = 250;       // products.json max per page
  var MAX_PAGES = 60;        // safety cap (15.000 products)

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function init() {
    var root = document.querySelector('[data-collection-search]');
    if (!root) return;

    var handle = root.getAttribute('data-handle');
    var count = parseInt(root.getAttribute('data-count'), 10) || 0;
    var currency = root.getAttribute('data-currency') || 'DKK';
    var locale = root.getAttribute('data-locale') || 'da';

    var input = root.querySelector('.mtw-colsearch__input');
    var clearBtn = root.querySelector('.mtw-colsearch__clear');
    var spinner = root.querySelector('.mtw-colsearch__spinner');
    var status = root.querySelector('[data-colsearch-status]');

    var parent = document.getElementById('CollectionProductsParent');
    if (!parent || !input) return;

    var origRow = parent.querySelector('[data-collection-products]');
    if (!origRow) return;
    var gridParent = origRow.parentNode;

    // Clone the real grid's classes so search results match the theme cards
    // (column sizing, white card box, padding) without hardcoding settings.
    var colClass = 'col-6 col-md-4 col-lg-4 col-xl-3';
    if (origRow.firstElementChild) {
      colClass = origRow.firstElementChild.className.replace(/^\s*\d+\s+/, '').trim() || colClass;
    }
    var protoItem = origRow.querySelector('.product-card-item');
    var itemClass = protoItem ? protoItem.className : 'product-card-item';
    var protoCard = origRow.querySelector('.product-card');
    var cardClass = protoCard ? protoCard.className : 'product-card product-background-enabled';

    var resultsRow = document.createElement('div');
    resultsRow.className = 'row mtw-colsearch-results';
    resultsRow.hidden = true;
    gridParent.appendChild(resultsRow);

    var money;
    try {
      money = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
    } catch (e) {
      money = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' kr.'; } };
    }

    var index = null;     // [{t, tl, u, img, p, vid, av}]
    var loading = false;
    var loadPromise = null;
    var cacheKey = 'mtwcs4:' + handle + ':' + count;  // mtwcs4: pris regnes nu kun paa lager-varianter -> gamle cachede indekser skal smides vaek
    var hiddenEls = [];

    function setStatus(html) {
      if (!status) return;
      if (html) { status.innerHTML = html; status.hidden = false; }
      else { status.hidden = true; status.innerHTML = ''; }
    }

    function fromCache() {
      try {
        var raw = sessionStorage.getItem(cacheKey);
        return raw ? JSON.parse(raw) : null;
      } catch (e) { return null; }
    }
    function toCache(arr) {
      try { sessionStorage.setItem(cacheKey, JSON.stringify(arr)); } catch (e) {}
    }

    function mapProduct(p) {
      var img = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';
      // Prisen skal regnes på varianter PÅ LAGER — ellers viser kortet prisen på en
      // udsolgt (billigere) variant, mens "Læg i kurv" tilføjer en dyrere. Spejler
      // snippets/price.liquid; udsolgt produkt falder tilbage til laveste pris i det hele.
      var availMin = null, availMax = null, availCount = 0;
      var anyMin = null;
      var vid = null, av = false;
      var vars = p.variants || [];
      for (var i = 0; i < vars.length; i++) {
        var v = parseFloat(vars[i].price);
        if (isNaN(v)) continue;
        if (anyMin === null || v < anyMin) anyMin = v;
        if (vars[i].available) {
          availCount++;
          if (availMin === null || v < availMin) availMin = v;
          if (availMax === null || v > availMax) availMax = v;
          if (vid === null) { vid = vars[i].id; av = true; }
        }
      }
      var price = availCount > 0 ? availMin : anyMin;
      var from = availCount > 1 && availMax > availMin;
      if (vid === null && vars.length) vid = vars[0].id;
      var tags = p.tags || '';
      if (tags && tags.join) tags = tags.join(' ');
      var search = ((p.title || '') + ' ' + tags).toLowerCase();
      return { t: p.title, tl: (p.title || '').toLowerCase(), s: search, u: '/products/' + p.handle, img: img, p: price, from: from, vid: vid, av: av };
    }

    function loadAll() {
      if (index) return Promise.resolve(index);
      if (loadPromise) return loadPromise;

      var cached = fromCache();
      if (cached && cached.length) { index = cached; return Promise.resolve(index); }

      loading = true;
      if (spinner) spinner.hidden = false;
      var acc = [];

      function fetchPage(page) {
        var url = '/collections/' + handle + '/products.json?limit=' + PAGE_SIZE + '&page=' + page;
        return fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (data) {
            var prods = (data && data.products) || [];
            for (var i = 0; i < prods.length; i++) acc.push(mapProduct(prods[i]));
            setStatus('Indlæser kollektionen… <b>' + acc.length + '</b> kort');
            if (prods.length === PAGE_SIZE && page < MAX_PAGES) return fetchPage(page + 1);
            return acc;
          });
      }

      loadPromise = fetchPage(1).then(function (arr) {
        index = arr;
        loading = false;
        if (spinner) spinner.hidden = true;
        toCache(arr);
        if (!input.value.trim()) setStatus('');   // clear the "Indlæser…" line once loaded & idle
        return index;
      }).catch(function () {
        loading = false;
        if (spinner) spinner.hidden = true;
        setStatus('Kunne ikke indlæse kollektionen til søgning.');
        return [];
      });
      return loadPromise;
    }

    function escapeHTML(s) {
      return (s || '').replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function cardHTML(item) {
      var imgTag = item.img
        ? '<img src="' + item.img + '" alt="" loading="lazy" width="300" height="300">'
        : '';
      var priceTag = (item.p !== null && item.p !== undefined)
        ? '<div class="mtw-colsearch__price">' + (item.from ? 'Fra ' : '') + money.format(item.p) + '</div>'
        : '';
      var cartBtn = (item.av && item.vid)
        ? '<form method="post" action="/cart/add" class="mtw-colsearch__atc">' +
            '<input type="hidden" name="id" value="' + item.vid + '">' +
            '<button type="submit" class="quick-add-btn button button--quickadd btn-block button-shadow">Læg i kurv</button>' +
          '</form>'
        : '<button class="quick-add-btn button button--quickadd btn-block button-shadow" disabled>Udsolgt</button>';
      return '<div class="' + colClass + '">' +
        '<div class="' + itemClass + '"><div class="' + cardClass + '">' +
          '<div class="product-card-img"><a class="product-img" href="' + item.u + '">' +
            '<div class="media" style="--imageRatio:100%">' + imgTag + '</div>' +
          '</a></div>' +
          '<div class="product-card-detail">' +
            '<a href="' + item.u + '" class="product-title">' + escapeHTML(item.t) + '</a>' +
            priceTag +
            '<div class="mtw-colsearch__actions">' +
              '<a class="button btn-block button-shadow" href="' + item.u + '">Se produkt</a>' +
              cartBtn +
            '</div>' +
          '</div>' +
        '</div></div></div>';
    }

    // Hide everything else in the grid container while searching (incl. anything
    // injected by third-party apps), and restore it exactly afterwards.
    function hideOthers() {
      var kids = gridParent.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (el === resultsRow || el.__mtwHidden) continue;
        el.__mtwHidden = true;
        el.__mtwPrevDisplay = el.style.display;
        el.style.display = 'none';
        hiddenEls.push(el);
      }
    }
    function showOthers() {
      for (var i = 0; i < hiddenEls.length; i++) {
        hiddenEls[i].style.display = hiddenEls[i].__mtwPrevDisplay || '';
        hiddenEls[i].__mtwHidden = false;
      }
      hiddenEls = [];
    }

    function showOriginal() {
      resultsRow.hidden = true;
      resultsRow.innerHTML = '';
      showOthers();
      setStatus('');
    }

    // Efter en AJAX-filtrering erstatter temaet grid-containeren, så vores
    // resultsRow/gridParent-referencer bliver forældede. Re-find dem her.
    function ensureRow() {
      if (resultsRow && document.body.contains(resultsRow)) return true;
      var p = document.getElementById('CollectionProductsParent');
      var row = p && p.querySelector('[data-collection-products]');
      if (!row) return false;
      gridParent = row.parentNode;
      if (!resultsRow || !document.body.contains(resultsRow)) {
        resultsRow = document.createElement('div');
        resultsRow.className = 'row mtw-colsearch-results';
        resultsRow.hidden = true;
      }
      gridParent.appendChild(resultsRow);
      hiddenEls = [];
      return true;
    }

    function runSearch(q) {
      q = (q || '').trim().toLowerCase();
      if (!q) { showOriginal(); return; }
      if (!ensureRow()) return;

      var tokens = q.split(/\s+/);
      var matches = [];
      for (var i = 0; i < index.length; i++) {
        var s = index[i].s || index[i].tl || '', ok = true;
        for (var k = 0; k < tokens.length; k++) {
          if (s.indexOf(tokens[k]) === -1) { ok = false; break; }
        }
        if (ok) { matches.push(index[i]); if (matches.length > 5000) break; }
      }

      hideOthers();

      if (!matches.length) {
        resultsRow.hidden = true;
        resultsRow.innerHTML = '';
        setStatus('<div class="mtw-colsearch-empty"><strong>Ingen kort matchede "' + escapeHTML(q) + '"</strong>Prøv et andet søgeord eller ryd søgningen.</div>');
        return;
      }

      var shown = matches.slice(0, MAX_RESULTS);
      var html = '';
      for (var m = 0; m < shown.length; m++) html += cardHTML(shown[m]);
      resultsRow.innerHTML = html;
      resultsRow.hidden = false;

      if (matches.length > MAX_RESULTS) {
        setStatus('Viser de første <b>' + MAX_RESULTS + '</b> af <b>' + matches.length + '</b> kort — forfin din søgning.');
      } else {
        setStatus('<b>' + matches.length + '</b> ' + (matches.length === 1 ? 'kort matcher' : 'kort matcher') + ' "' + escapeHTML(q) + '"');
      }
    }

    var debouncedSearch = debounce(function (val) {
      if (!index) {
        loadAll().then(function () { runSearch(val); });
      } else {
        runSearch(val);
      }
    }, 130);

    // Warm the index as soon as the user engages the field
    input.addEventListener('focus', function () { loadAll(); }, { once: true });

    input.addEventListener('input', function () {
      var val = input.value;
      if (clearBtn) clearBtn.hidden = !val;
      if (!val.trim()) { showOriginal(); return; }
      if (!index && !loading) setStatus('Indlæser kollektionen…');
      debouncedSearch(val);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        showOriginal();
        input.focus();
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
